import keyMirror from "ramda-extension/es/keyMirror";
export const actionTypes = keyMirror({
    SAVE_DELEGATIONS: null
});
export const EXCLUDE_URL_REDIRECT = [
    'login/error',
    'login/no-access',
    'logout',
    'delegations',
    'not-found'
];
export const COMPANY_STR = {
    CP: 'CP',
    GLI: 'GLI'
};
export const COMPANY_NUM = {
    1: 'CP',
    8: 'GLI'
};
export const REDUCER_NAME = 'delegations';
export default {
    actionTypes,
    REDUCER_NAME
};
